import checkout from "./form";

const {
  formField: {
    address,
    email,
    fax,
    firstTime,
    phone,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxpayerName,
    address2,
    agencyContract,
    agencyContractDate,
    district,
    district2,
    organizationPayingName,
    province,
    province2,
    taxId1,
    taxId2,
    certificate,
    signer,
    fullName,
    timeSign,
  },
} = checkout;

const initialValues = {
  [address.name]: "",
  [address2.name]: "",
  [email.name]: "",
  [fax.name]: "",
  [firstTime.name]: false,
  [phone.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [agencyContract.name]: "",
  [agencyContractDate.name]: "",
  [district.name]: "",
  [district2.name]: "",
  [province.name]: "",
  [province2.name]: "",
  [organizationPayingName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
